// Date selector button with Today button
// CREATED: Reusable component extracted from MyTasksView pattern
// Shows formatted date with calendar icon and chevron, plus Today button
// Used in: TeamView mobile header for consistent date selection UX

import { Calendar, ChevronDown, ChevronUp } from 'lucide-react';

interface DateSelectorButtonProps {
  currentDate: string; // YYYY-MM-DD format
  showCalendar: boolean;
  onToggleCalendar: () => void;
  onGoToToday: () => void;
}

export function DateSelectorButton({
  currentDate,
  showCalendar,
  onToggleCalendar,
  onGoToToday
}: DateSelectorButtonProps) {
  const isToday = currentDate === new Date().toISOString().split('T')[0];

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onToggleCalendar}
        className="inline-flex items-center gap-2 px-4 py-2.5 text-sm bg-white hover:bg-gray-50 border border-gray-300 rounded-lg transition-all duration-200 shadow-sm active:scale-95 min-h-[44px]"
        aria-expanded={showCalendar}
        aria-label="Sélectionner une date"
        type="button"
      >
        <Calendar size={16} className="text-gray-700" />
        <span className="font-medium text-gray-900">
          {new Date(currentDate + 'T00:00:00').toLocaleDateString('fr-FR', {
            weekday: 'short',
            day: 'numeric',
            month: 'short'
          })}
        </span>
        {showCalendar ? (
          <ChevronUp size={16} className="text-gray-700" />
        ) : (
          <ChevronDown size={16} className="text-gray-700" />
        )}
      </button>

      {!isToday && (
        <button
          onClick={onGoToToday}
          className="px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 shadow-sm min-h-[44px] bg-primary-600 text-white hover:bg-primary-700 active:scale-95"
          aria-label="Revenir à aujourd'hui"
          type="button"
        >
          Aujourd'hui
        </button>
      )}
    </div>
  );
}
